<template>
  <div class="new-content">
    <div style="width:90%;margin:0 auto;">
      <div :class="['query-inputs', importerAll.length > 1 ? 'mic' : '']">
        <div class="inputs clearfix">
          <Select v-model.trim="importerID" v-if="importerAll.length > 1">
            <Option v-for="item in importerAll" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <Input class="search" v-model="searchVal" clearable type="text" :placeholder="$t('newsActivity.searchPlaceholder')" style="width:100%" @on-enter="search"/>
        </div>
        <div class="btn-wrap clearfix">
          <Button type="primary" class="btn search" :loading="isShowLoader" @click.prevent="search">
            <span v-if="!isShowLoader"><span>{{$t('btn.search')}}</span></span>
            <span v-else>{{$t('common.loading')}}</span>
          </Button>
          <Button class="btn reset" type="primary" @click.prevent="reset" :disabled="isShowLoader"><span>{{$t('btn.reset')}}</span></Button>
        </div>
      </div>
      <table cellpadding="0" cellspacing="0" style="margin-bottom:0" v-if="!_.isEmpty(dataSet.result)">
        <thead>
          <tr>
            <th>{{$t('codeQuery.tb.col1')}}</th>
            <th>{{$t('codeQuery.tb.col2')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dataSet.result" :key="`code-${index}`">
            <td>{{item.code | specialHSCodeValue}}</td>
            <td>{{item.name}}</td>
          </tr>
        </tbody>
      </table>
      <div class="nodata" v-else>{{$t('common.noResult')}}</div>
      <Page :total="dataSet.count" :page-size="pageSize" :current.sync="currentPage" size="small" @on-change="goPager" v-if="dataSet.count > pageSize"></Page>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-55px;"></Loader>
  </div>
</template>

<script>
import Loader from '../layout/Loader'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'CodeDictQueryListContent',
  components: { Loader },
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    pageSize: {
      type: Number
    },
    isShowLoader: {
      type: Boolean
    }
  },
  data () {
    return {
      searchVal: '',
      currentPage: 1,
      importerID: null
    }
  },
  computed: {
    ...mapDataState({
      defaultPlaceholder: state => state.importerPlaceholder,
      importerAll: state => state.importerAll
    })
  },
  watch: {
    defaultPlaceholder (newVal, oldVal) {
      if (newVal && this.importerAll.length > 1) {
        this.importerID = newVal.id
      }
    }
  },
  mounted () {
    if (this.defaultPlaceholder && this.importerAll && this.importerAll.length > 1) {
      this.importerID = this.defaultPlaceholder.id
    }
  },
  methods: {
    goPager (page) {
      this.$parent.getData(page, this.importerID, this._.trim(this.searchVal))
    },
    search () {
      this.goPager(1)
    },
    reset () {
      this.searchVal = ''
      if (this.defaultPlaceholder && this.importerAll.length > 1) {
        this.importerID = this.defaultPlaceholder.id
      }
      this.goPager(1)
    }
  }
}
</script>
<style scoped>
  .new-content{
    margin-top: 30px;
  }
  .new-content >>> .ivu-page{
    text-align: center;
    margin: 36px 0 15px;
  }
  .new-content >>> .ivu-page-item-active{
    background-color: #1F8AFD;
    border-color: #1F8AFD;
  }
  .query-inputs{
    position: relative;
    padding-right: 245px;
    margin-bottom: 30px;
  }
  .query-inputs >>> .ivu-input{
    border-radius: 2px;
    padding: 4px 11px;
    font-size: 14px;
  }
  .mic.query-inputs .inputs{
    position: relative;
    padding-left: 115px;
  }
  .mic.query-inputs >>> .ivu-select{
    /*float: left;*/
    width: 110px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .mic.query-inputs >>> .ivu-select .ivu-select-selection{
    border-radius: 2px;
  }
  .mic.query-inputs >>> .ivu-select .ivu-select-selection .ivu-select-selected-value{
    font-size: 13px;
  }
  .mic.query-inputs >>> .ivu-select-dropdown-list .ivu-select-item{
    font-size: 13px !important;
  }
  .btn-wrap{
    position: absolute;
    top:0;
    right: 0;
    height: 100%;
    margin-left: 8px;
  }
  .btn{
    width: 110px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 100%;
    float: left;
    /*font-size: 11px;*/
    font-size: 13px;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.search{
    background-color: #1F8AFD;
    color: #fff;
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .btn.reset{
    background-color: #fff;
    color: #1F8AFD;
    margin-left: 8px;
  }
  .btn.reset[disabled]{
    color: #bbbec4;
    border-color: #dddee1;
    cursor: default;
  }
  table{
    width: 100%;
    background-color: #fff;
    box-shadow: -2px 0 4px 0 rgba(232,232,232,0.50), 0 -2px 4px 0 rgba(232,232,232,0.50), 2px 0 4px 0 rgba(232,232,232,0.50), 0 2px 4px 0 rgba(232,232,232,0.50);
    /*font-size: 11px;*/
    font-size: 13px;
    color: #333;
    margin-bottom: 10px;
  }
  table thead{
    box-shadow: 0 2px 4px 0 rgba(232,232,232,0.60);
  }
  table thead th{
    color: #1F8AFD;
    font-weight: normal;
    text-align: center;
    padding: 9px 5px;
    /*font-size: 11px;*/
    font-size: 13px;
    border-bottom: 1px solid #ececec;
  }
  table thead th:first-child{
    border-right: 1px solid #ececec;
  }
  table thead th,
  table tbody td{
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
  }
  table thead th:first-child,
  table tbody td:first-child{
    width: 150px;
    /*white-space: normal;*/
  }
  table tbody tr:hover td{
    /*background-color: #ebf7ff !important;*/
    background-color: rgba(202, 234, 255, 0.4) !important;
  }
  table tbody tr td{
    border-bottom: 1px solid #ececec;
    text-align: left;
    padding: 9px 15px;
    /*font-size: 12px;*/
    font-size: 14px;
  }
  table tbody tr td:first-child{
    border-right: 1px solid #ececec;
    /*font-weight: bold;*/
    /*font-size: 11px;*/
    font-size: 13px;
    padding: 9px 20px;
    /*padding: 9px 0;*/
    /*text-align: center;*/
  }
  table tbody tr:last-child td{
    border-bottom: 0;
  }
  table tbody tr:nth-child(odd) td{
    background-color: #F8F8F8;
  }
  table tbody tr:nth-child(odd) td:first-child{
    background-color: #fff;
  }
  .nodata{
    text-align: center;
    padding-top: 30px;
    /*font-size: 12px;*/
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/codeQuery/ListContent.vue